import { useState } from "react";
import { scrollToId } from "../lib/scroll";
import LegalNotice from "./LegalNotice";

export default function Footer() {
  const [legalOpen, setLegalOpen] = useState(false);
  return (
    <footer data-testid="site-footer" className="relative border-t border-[#D4AF37]/10 bg-[#0A1120] py-14">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex items-center gap-4">
          <img src="/assets/signature.png" alt="Monogramme FV" className="h-10 w-10 object-contain" />
          <div>
            <p className="font-serif-display text-lg text-white">Frédérique Vasseur</p>
            <p className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-slate-500">
              Accompagnement · Leadership · QVT
            </p>
          </div>
        </div>

        <nav className="flex flex-wrap justify-center gap-6 text-sm text-slate-400">
          <button data-testid="footer-link-approche" onClick={() => scrollToId("#approche")} className="hover:text-[#F3E5AB] transition-colors">L'approche</button>
          <button data-testid="footer-link-pme" onClick={() => scrollToId("#dirigeants")} className="hover:text-[#F3E5AB] transition-colors">Dirigeants & QVT</button>
          <button data-testid="footer-link-individuel" onClick={() => scrollToId("#individuel")} className="hover:text-[#F3E5AB] transition-colors">Individuel</button>
          <button data-testid="footer-link-contact" onClick={() => scrollToId("#contact")} className="hover:text-[#F3E5AB] transition-colors">Contact</button>
          <button data-testid="footer-link-legal" onClick={() => setLegalOpen(true)} className="hover:text-[#F3E5AB] transition-colors">Mentions légales</button>
        </nav>

        <p className="text-xs text-slate-500 text-center md:text-right leading-relaxed">
          Vendargues & alentours — et à distance partout en France<br />
          <a data-testid="footer-phone-link" href="tel:+33744774445" className="hover:text-[#F3E5AB] transition-colors">07 44 77 44 45</a>
          {" · "}
          <a data-testid="footer-email-link" href="mailto:contact@frederiquevasseur.com" className="hover:text-[#F3E5AB] transition-colors">contact@frederiquevasseur.com</a><br />
          © {new Date().getFullYear()} Frédérique Vasseur. Tous droits réservés.
        </p>
      </div>
      <LegalNotice open={legalOpen} onClose={() => setLegalOpen(false)} />
    </footer>
  );
}
